interface JsonLdProps {
  data: Record<string, unknown>[];
}

export default function JsonLd({ data }: JsonLdProps) {
  const json = JSON.stringify({
    "@context": "https://schema.org",
    "@graph": data,
  });

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: json }}
    />
  );
}